import addiesaas, {Vue} from '~/addiesaas'

import config from '~/vuestrap/config'
import store from '~/vuestrap/vuexstore'
import { makeRouter } from '~/vuestrap/router'
import i18n from '~/vuestrap/locale'

// import 'moment/locale/en'

const EventBus = window.VueEventBus

import '../init'

const router = makeRouter({ mode: 'history' })

const vuestrap = { i18n, store, router }

router.afterEach((to, from) => {
    EventBus.$emit('lairdnd-messages-read')
})

addiesaas.spa = addiesaas.spa || {
    ...config,
    instances: [],
    async init(el, options) {
        const strap = {...vuestrap, ...options || {}, router, el}

        EventBus.$emit('addiesaas.app.beforeInit', el, addiesaas, strap)

        const instance = new Vue(strap);
        window.addiesaas.spa.instances.push(instance)

        EventBus.$emit('addiesaas.app.init', instance, addiesaas, strap)

        return instance
    },
}
